/** Service Desk console: mga hiling ng spare part (AST-092, SD-S4-06). */
export const serviceSpares = {
  title: "Mga spare part",
  tab: "Mga spare part",
  subtitle: "Ang hiniling ng mga engineer sa warehouse, ang napili na at ang naibigay na.",
  progress: "Progreso ng hiling",
  status: { requested: "Hiniling", picked: "Napili", issued: "Naibigay", cancelled: "Kinansela" },
  stepState: { done: "tapos na", current: "kasalukuyang hakbang", pending: "hindi pa" },
  actions: {
    create: "Humiling ng spare part",
    request: "Humiling ng spare part",
    pick: "Markahang napili",
    issue: "Markahang naibigay…",
    edit: "I-edit",
    cancel: "Kanselahin ang hiling",
    send: "Ipadala sa stock system…",
    sendAgain: "Ipadala ulit sa stock system…",
  },
  filters: {
    group: "I-filter ayon sa status",
    chip: { all: "Lahat", requested: "Hiniling", picked: "Napili", issued: "Naibigay", cancelled: "Kinansela" },
    search: "Maghanap ayon sa numero, SKU o pangalan ng part",
    searchLabel: "Maghanap ng mga hiling ng spare part",
    mine: "Akin lang",
    clear: "I-clear ang mga filter",
  },
  list: {
    label: "Mga hiling ng spare part",
    loading: "Nilo-load ang mga hiling ng spare part",
    number: "Hiling",
    partsHeader: "Mga part",
    for: "Para sa",
    status: "Status",
    neededBy: "Kailangan sa",
    asked: "Hiniling",
    asset: "Asset",
    noLink: "Walang ticket o asset",
    open: "Buksan ang hiling ng spare part {{number}}",
    parts_one: "{{count}} part sa {{lines}} linya",
    parts_other: "{{count}} part sa {{lines}} linya",
    more_one: "{{count}} pang linya",
    more_other: "{{count}} pang linya",
    showing: "Ipinapakita ang {{shown}} sa {{total}}",
    errorTitle: "Hindi ma-load ang mga hiling ng spare part",
    errorBody: "Tingnan ang koneksyon mo at subukan ulit. Walang binago.",
  },
  empty: {
    title: "Wala pang hiling ng spare part",
    body: "Kapag may kailangang part ang engineer para sa pagkukumpuni, lalabas dito ang hiling para piliin at ibigay ng warehouse.",
    filteredTitle: "Walang tumutugmang hiling",
    filteredBody: "Subukan ang ibang status o mas maikling hanap.",
  },
  form: {
    title: "Humiling ng spare part",
    hint: "Ilista ang bawat part nang minsan lang kasama ang dami. Pipiliin at ibibigay ito ng warehouse.",
    editTitle: "I-edit ang {{number}}",
    editHint: "Maaaring baguhin ang hiling hangga't hindi pa ito napipili ng warehouse.",
    forContext: "Para sa",
    lines: "Mga part",
    sku: "SKU",
    name: "Pangalan ng part",
    qty: "Dami",
    skuOf: "SKU ng part {{number}}",
    nameOf: "Pangalan ng part {{number}}",
    qtyOf: "Dami ng part {{number}}",
    removeLine: "Alisin ang part {{number}}",
    addLine: "Magdagdag ng part",
    neededBy: "Kailangan sa",
    neededByHint: "Opsyonal. Ang araw na dapat nasa engineer na ang part.",
    note: "Tala para sa warehouse",
    noteHint: "Opsyonal. Hindi ipinapadala sa stock system.",
    submit: "Ipadala ang hiling",
    save: "I-save ang mga pagbabago",
    created: "Naipadala sa warehouse ang hiling na {{number}}",
    updated: "Na-update ang hiling na {{number}}",
    problems: {
      sku: "Ilagay ang SKU.",
      duplicate: "Nasa hiling na ang SKU na ito.",
      name: "Ilagay ang pangalan ng part.",
      qty: "Maglagay ng buong numero mula 1 hanggang {{max}}.",
      tooMany: "Hanggang {{max}} part lang ang laman ng isang hiling.",
    },
  },
  drawer: {
    title: "Hiling ng spare part {{number}}",
    titleLoading: "Hiling ng spare part",
    loading: "Nilo-load ang hiling",
    actions: "Mga aksyon sa hiling",
    lines: "Mga part",
    linesLabel: "Mga part sa hiling na ito",
    part: "Part",
    asked: "Hiniling",
    issued: "Naibigay",
    short: "Kulang",
    details: "Mga detalye",
    ticket: "Ticket",
    asset: "Asset",
    visit: "Pagbisita",
    openAsset: "Buksan ang asset",
    openVisit: "Buksan ang pagbisita",
    neededBy: "Kailangan sa",
    requested: "Hiniling",
    quantity: "Dami",
    parts_one: "{{count}} part sa {{lines}} linya",
    parts_other: "{{count}} part sa {{lines}} linya",
    pickedAt: "Napili noong {{at}}",
    issuedAt: "Naibigay noong {{at}}",
    cancelled: "Kinansela ang hiling na ito.",
    cancelledWhy: "Kinansela ang hiling na ito: {{reason}}",
  },
  pick: { done: "Namarkahang napili ang hiling na {{number}}" },
  issue: {
    title: "Ibigay ang {{number}}",
    hint: "Ilagay ang naibigay ng warehouse. Iwanan ang mga dami kung buo ang ibibigay sa bawat linya.",
    asked_one: "{{count}} ang hiniling",
    asked_other: "{{count}} ang hiniling",
    issued: "Naibigay",
    issuedOf: "Dami ng naibigay para sa {{sku}}",
    problem: "Maglagay ng buong numero mula 0 hanggang {{max}}.",
    invalid: "Ayusin ang mga dami sa itaas. Hindi puwedeng lampas sa hiniling ang maibigay.",
    submit: "Markahang naibigay",
    done: "Naibigay ang hiling na {{number}}",
  },
  cancel: {
    title: "Kanselahin ang {{number}}?",
    hint: "Titigil ang warehouse sa paggawa nito. Hindi na mabubuksan ulit ang kinanselang hiling.",
    reason: "Dahilan",
    reasonHint: "Opsyonal. Mananatili ito sa hiling.",
    keep: "Panatilihin ang hiling",
    submit: "Kanselahin ang hiling",
    done: "Kinansela ang hiling na {{number}}",
  },
  send: {
    title: "Ipadala ang {{number}} sa stock system?",
    body: "Isusulat nito ang hiling sa purchasing system mo gamit ang connector operation na create_stock_request. Ipinapadala ang mga SKU at dami; hindi ang tala.",
    once: "Isang beses lang isinusulat ang hiling. Kung tanggihan ng sistema, puwede mo itong ipadala ulit.",
    confirm: "Ipadala sa stock system",
    done: "Naipadala sa stock system ang hiling na {{number}}",
  },
  external: {
    sent: "Naipadala sa purchasing system {{at}}.",
    reference: "Reference {{reference}}",
    failed: "Hindi tinanggap ng purchasing system ang hiling na ito (code {{code}}). Puwede mo itong ipadala ulit.",
    unavailable: "Hindi pa naka-set up ang pagpapadala sa stock system: walang nai-publish na operation na create_stock_request ang connector ng commerce profile.",
  },
  context: {
    title: "Mga spare part",
    none: "Walang hiniling na spare part para sa ticket na ito.",
    noneVisit: "Walang hiniling na spare part para sa pagbisitang ito.",
    error: "Hindi ma-load ang mga spare part.",
  },
  errors: {
    noStockOperation: "Walang nai-publish na operation na create_stock_request ang connector ng commerce profile. Hilingin sa admin na i-publish ito.",
    alreadySent: "Naisulat na sa purchasing system ang hiling na ito.",
    invalidTransition: "Hindi na available ang hakbang na iyon para sa hiling na ito. Mag-reload para makita kung nasaan ito.",
    notFound: "Wala na ang hiling na ito o ang tinutukoy nito.",
    plan: "Hindi kasama sa plan mo ito.",
    forbidden: "Wala kang pahintulot na gawin iyon.",
  },
} as const;
